import React from 'react';

export const AuthenticationLayout = ({
  rightImage,
  children,
}: {
  rightImage: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={`h-screen max-w-[1728px] p-[100px] sxl:px-[150px] sxl:py-[168px] flex justify-center sxl:justify-start gap-[127px]`}
    >
      <div>{children}</div>
      <div className={`hidden sxl:block flex-grow`}>
        <img src={rightImage} alt="Welcome" className="w-full h-auto" />
      </div>
    </div>
  );
};
